var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "popSellGift"
  }, [_c('pop-dialog', {
    attrs: {
      "closeModel": _vm.rowTrade && _vm.isGetToTelegramConfirm ? false : true,
      "show": _vm.popGetToTelegramShow,
      "height": "auto",
      "width": "80%"
    },
    on: {
      "update:show": function ($event) {
        _vm.popGetToTelegramShow = $event;
      }
    }
  }, [_vm.rowTrade ? _c('div', {
    staticClass: "pop-main"
  }, [_c('div', {
    staticClass: "title"
  }, [[!_vm.isGetToTelegramConfirm ? [_vm._v("Are you sure you want to"), _c('br'), _vm._v(" receive this gift")] : [_c('div', {
    staticClass: "title__label"
  }, [_vm._v("The gift is being distributed.")]), _c('div', {
    staticClass: "title__value"
  }, [_vm._v("This may take several hours. Please wait...")])]]], 2), !_vm.isGetToTelegramConfirm ? _c('div', {
    staticClass: "sub"
  }, [[_vm._v("You won't be able to exchange it"), _c('br'), _vm._v(" for Telegram stars afterwards")]], 2) : _vm._e(), !_vm.isGetToTelegramConfirm ? _c('div', {
    staticClass: "btn-confirm",
    on: {
      "click": _vm.onGetToTelegrmaGet
    }
  }, [!_vm.isBtnLoading ? [_vm._v("Get")] : [_c('div', {
    staticClass: "circleLoading"
  })]], 2) : _c('div', {
    staticClass: "btn-confirm",
    on: {
      "click": _vm.onOpenRobit
    }
  }, [_vm._v("You will receive gifts here "), _c('svg-icon', {
    attrs: {
      "name": "icon-rightarrow"
    }
  }), _c('img', {
    attrs: {
      "src": require(`@images/tapcoin/robot-logo.jpg`),
      "alt": ""
    }
  })], 1)]) : _vm._e()]), _c('pop-dialog', {
    attrs: {
      "show": _vm.popSellPlatformShow,
      "height": "auto",
      "width": "80%"
    },
    on: {
      "update:show": function ($event) {
        _vm.popSellPlatformShow = $event;
      }
    }
  }, [_vm.rowTrade ? _c('div', {
    staticClass: "pop-main"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Are you sure you want to sell it?")]), _c('div', {
    staticClass: "sub"
  }, [_vm._v(_vm._s(_vm.fmt_pre(_vm.rowTrade?.recycling_stars))), _c('img', {
    attrs: {
      "src": require(`@images/tapcoin/ton-stars.png`),
      "alt": ""
    }
  }), _vm._v("will be credited to your balance")]), _c('div', {
    staticClass: "btn-confirm",
    on: {
      "click": _vm.onSubmitSellPlatform
    }
  }, [!_vm.isBtnLoading ? [_vm._v("Submit")] : [_c('div', {
    staticClass: "circleLoading"
  })]], 2)]) : _vm._e()])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };